import s from './ProvidedBy.module.scss';

export default function ProvidedBy() {
  return (
    <p className={s.note}>
      This service is provided to you by <strong>West Bridge Ltd</strong>.
    </p>
  );
}
